import { useState } from "react";
import type { ParcelFlag } from "./api";

// Lightweight folio/address lookup against the static seed.
// In a backed deploy this would call a real geocoder; for the demo it filters
// the opportunities feed by folio substring or address substring.

export function Search({ onPick }: { onPick: (folio: string) => void }) {
  const [q, setQ] = useState("");
  const [matches, setMatches] = useState<ParcelFlag[]>([]);

  async function run(query: string) {
    setQ(query);
    if (query.length < 2) { setMatches([]); return; }
    const r = await fetch("/sample/opportunities.json");
    const all = (await r.json()) as Array<{ parcel: ParcelFlag }>;
    const ql = query.toLowerCase();
    const hits = all
      .map((x) => x.parcel)
      .filter((p) => p.folio.toLowerCase().includes(ql) || (p.address ?? "").toLowerCase().includes(ql))
      .slice(0, 6);
    setMatches(hits);
  }

  return (
    <div className="ps-search">
      <input
        className="ps-search__input"
        value={q}
        onChange={(e) => run(e.target.value)}
        placeholder="Search folio or address — e.g. 30-4042 or NW 4th St"
        spellCheck={false}
      />
      {matches.length > 0 && (
        <ul className="ps-search__menu">
          {matches.map((m) => (
            <li key={m.folio} onClick={() => { onPick(m.folio); setQ(m.folio); setMatches([]); }}>
              <span className="ps-search__folio">{m.folio}</span>
              {m.opportunityScore !== null && <span className="ps-search__score">{Math.round(m.opportunityScore)}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
